import { cloneDeep, get, set } from 'es-toolkit/compat'
import { Theme } from '../../types'

interface MergeThemeWithValuesOptions {
  /**
   * Theme to merge from.
   */
  from: Theme
  /**
   * Theme to merge with.
   */
  to: Theme
  /**
   * Array of paths to keep from the from theme.
   */
  keep: string[]
}

/**
 * Merge the theme with the keep values.
 * @param options
 * @returns
 */
export const mergeThemeWithValues = ({ from, to, keep }: MergeThemeWithValuesOptions) => {
  const merged = cloneDeep(to)

  keep.forEach(path => {
    set(merged, path, get(from, path))
  })

  return merged
}
